import { api } from '@/utils/apiService';

const defaultStats = () => ({ rating: 0, amountVotes: 0, unreadNotifications: 0 });

const review = {
  namespaced: true,
  state: {
    reviews: [],
    stats: defaultStats(),
    notifications: [],
  },
  mutations: {
    SET_REVIEWS(state, list) {
      state.reviews = Array.isArray(list) ? list : [];
    },
    SET_STATS(state, stats) {
      state.stats = stats || defaultStats();
    },
    SET_NOTIFICATIONS(state, list) {
      state.notifications = Array.isArray(list) ? list : [];
    },
  },
  getters: {
    getReviews: (state) => state.reviews,
    getStats: (state) => state.stats,
    getUnreadCount: (state) => state.stats.unreadNotifications || 0,
    getNotifications: (state) => state.notifications,
  },
  actions: {
    fetchReviews: async ({ commit }) => {
      try {
        const res = await api.get('/review');
        if (res.status !== 200) {
          commit('SET_REVIEWS', []);
          return [];
        }
        const list = Array.isArray(res.data) ? res.data : [];
        commit('SET_REVIEWS', list);
        return list;
      } catch (e) {
        console.error('fetchReviews:', e);
        commit('SET_REVIEWS', []);
        return [];
      }
    },
    fetchStats: async ({ commit }) => {
      try {
        const res = await api.get('/review/stats');
        if (res.status !== 200) return null;
        const stats = res.data && typeof res.data === 'object' ? res.data : defaultStats();
        commit('SET_STATS', stats);
        return stats;
      } catch (e) {
        console.error('fetchStats:', e);
        return null;
      }
    },
    fetchNotifications: async ({ commit }) => {
      try {
        const res = await api.get('/review/company/notifications');
        if (res.status !== 200) {
          commit('SET_NOTIFICATIONS', []);
          return [];
        }
        const list = Array.isArray(res.data) ? res.data : [];
        commit('SET_NOTIFICATIONS', list);
        return list;
      } catch (e) {
        console.error('fetchNotifications:', e);
        commit('SET_NOTIFICATIONS', []);
        return [];
      }
    },
    markAllNotificationsRead: async ({ state, dispatch }) => {
      const unread = (state.notifications || []).filter((n) => !n.readAt);
      if (!unread.length) return;
      await Promise.all(
        unread.map(async (notification) => {
          try {
            const res = await api.patch(
              `/review/company/notifications/${notification.notificationID}/read`,
            );
            if (res.status !== 204) {
              console.warn('markAllNotificationsRead:', notification.notificationID, res.status);
            }
          } catch (e) {
            console.warn('markAllNotificationsRead:', notification.notificationID, e);
          }
        }),
      );
      await dispatch('fetchStats');
      await dispatch('fetchNotifications');
    },
    markNotificationRead: async ({ dispatch }, notificationID) => {
      const res = await api.patch(`/review/company/notifications/${notificationID}/read`);
      if (res.status !== 204) {
        throw res;
      }
      await dispatch('fetchStats');
      await dispatch('fetchNotifications');
    },
    replyToReview: async ({ dispatch }, { reviewID, message, specialID }) => {
      const res = await api.post(`/review/${reviewID}/reply`, { message, specialID });
      if (res.status === 200) {
        await dispatch('fetchReviews');
        await dispatch('fetchStats');
        return res.data;
      }
      throw res;
    },
    loadAll: async ({ dispatch }) => {
      await Promise.all([
        dispatch('fetchReviews'),
        dispatch('fetchStats'),
        dispatch('fetchNotifications'),
      ]);
    },
  },
};

export default review;
